// extracted by mini-css-extract-plugin
export default {"title":"d0f010fd43","inner_title":"_4eea4eba71","charge_btn":"_1aeb82bf7b"};